<template>
    <select class="form-control" name="type" id="type" @change="onChange($event)">
		<option value=""></option>
		<option value="header" :selected="selectedValue == 'header'" >Header</option>
		<option value="footer" :selected="selectedValue == 'footer'" >Footer</option>
		<option value="submenu" :selected="selectedValue == 'submenu'" >Submenu</option>
	</select>
</template>

<script>
    export default {
        name: 'type-selector',
		emits: ['update'],
        props: {
        	selectedValue : {
				type: String
			}
        },
        data () {
			return {
				value : '',
			};
		},
		methods: {
			onChange(event) {
				let optionSelected = event.target.value;
				this.value = optionSelected;
				this.$emit('update', optionSelected);
			}
		}
    }
</script>
